import { locale } from "../locale"
import { getItem, setItem } from "../storage"
import { Bulma } from "../view/bulma"
import { MaterialDesign } from "../view/material_design"
import { getNotices } from "./notices_api"

async function noticesSection() {
    let notices = await getNotices(true)
    const noticeIds = notices.map(n => n.Id)

    // cleanup read notice ids
    /** @type {string[]} */
    let readNoticeIds = JSON.parse(await getItem("read-notice-ids") || "[]")
    readNoticeIds = readNoticeIds.filter(id => noticeIds.includes(id))
    await setItem("read-notice-ids", JSON.stringify(readNoticeIds))

    // remove read notices
    notices = notices.filter(n => !readNoticeIds.includes(n.Id))

    return Bulma.section(
        {
            hidden: notices.length < 1,
        },
        ...notices.map(n => noticeCard(n)),
    )
}

/**
 * @param {Notice} notice 
 */
function noticeCard(notice) {
    const setRead = async () => {
        const parent = card.parentElement
        if (!parent) return

        // add to read ids
        const readNoticeIds = JSON.parse(await getItem("read-notice-ids") || "[]")
        readNoticeIds.push(notice.Id)
        await setItem("read-notice-ids", JSON.stringify(readNoticeIds))

        // remove card and hide section if empty
        card.remove()
        if (!parent.hasChildNodes()) parent.classList.add("is-hidden")
    }

    const card = Bulma.card(
        Bulma.cardHeader({},
            Bulma.cardHeaderTitle(locale.string({
                enGB: notice.English,
                deDE: notice.German,
                frFR: notice.French,
                svSE: notice.Swedish,
            })),
            Bulma.cardHeaderIcon(MaterialDesign.icon({
                id: "close",
                onClick: setRead,
            })),
        ),
    )

    return card
}

export {
    noticesSection
}
